import { getCustomerByCnpj } from "./api";
import { getCompanyLogoUrl } from "./publicLogo";

/**
 * Logo cadastrado de qualquer empresa, pelo CNPJ.
 * Um pedido por loja, compartilhado por todas as telas.
 * Não usar useCustomer aqui: ele traz o cardápio inteiro e atropela as outras lojas.
 */
const cache = new Map<string, string>();
const inflight = new Map<string, Promise<string>>();
const listeners = new Set<() => void>();

function digitsOf(cnpj?: string | null): string {
  return (cnpj || "").replace(/\D/g, "");
}

function emit() {
  listeners.forEach((fn) => fn());
}

export function rememberStoreLogo(cnpj?: string | null, url?: string | null) {
  const digits = digitsOf(cnpj);
  const clean = (url || "").trim();
  if (digits.length !== 14 || !clean) return;
  if (cache.get(digits) === clean) return;
  cache.set(digits, clean);
  emit();
}

export function peekStoreLogo(cnpj?: string | null): string {
  return cache.get(digitsOf(cnpj)) || "";
}

export function subscribeStoreLogos(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function loadStoreLogo(cnpj?: string | null): Promise<string> {
  const digits = digitsOf(cnpj);
  if (digits.length !== 14) return Promise.resolve("");
  const known = cache.get(digits);
  if (known) return Promise.resolve(known);
  const pending = inflight.get(digits);
  if (pending) return pending;
  const job = getCustomerByCnpj(digits, { forceRefresh: false, scope: "internal" })
    .then((res) => {
      const url = getCompanyLogoUrl(res?.cliente);
      if (url) rememberStoreLogo(digits, url);
      return url;
    })
    .catch(() => "")
    .finally(() => {
      inflight.delete(digits);
    });
  inflight.set(digits, job);
  return job;
}
